import { render, staticRenderFns } from "./bookRepositorySearch.vue?vue&type=template&id=1879b0c3&"
import script from "./bookRepositorySearch.vue?vue&type=script&lang=js&"
export * from "./bookRepositorySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports